




import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsappFloatButton = () => {

  const handleClick = () => {
    window.open(`https://api.whatsapp.com/send/?phone=918639542319&text&type=phone_number&app_absent=0`, "_blank");
  };

  return (
    <div className="fixed bottom-8 right-8 z-50">
      <button
        onClick={handleClick}
        className="group w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-xl flex items-center justify-center transition-all duration-300 ease-in-out hover:scale-110 active:scale-95"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="text-3xl animate-pulse group-hover:animate-none transition-transform duration-500 ease-in-out" />
      </button>
    </div>
  );
};

export default WhatsappFloatButton;
